import React from 'react';
import PropTypes from 'prop-types';
import If from '../../utils/react-if';
import * as SharedStyle from '../../shared-style';

var STYLE_LINE = {
  fill: "#0096fd",
  stroke: "#0096fd"
};

var STYLE_CIRCLE = {
  fill: "#0096fd",
  stroke: "#0096fd",
  cursor: "ew-resize"
};

var STYLE_CIRCLE2 = {
  fill: "none",
  stroke: "#0096fd",
  cursor: "ew-resize"
};

export default function Item(_ref) {
  var layer = _ref.layer,
      item = _ref.item,
      scene = _ref.scene,
      catalog = _ref.catalog,
      isDesktop = _ref.isDesktop;
  var x = item.x,
      y = item.y,
      rotation = item.rotation;


  var renderedItem = catalog.getElement(item.type).render2D(item, layer, scene);
  var removePoint = 50;
  return React.createElement(
    'g',
    {
      'data-element-root': true,
      'data-prototype': item.prototype,
      'data-id': item.id,
      'data-selected': item.selected,
      'data-layer': layer.id,
      style: item.selected ? { cursor: "move" } : {},
      transform: 'translate(' + x + ',' + y + ') rotate(' + rotation + ')' },
    renderedItem,
    item && item.type !== 'vertical-gas-pipe' && item.type !== 'vertical-water-pipe' && item.type !== 'round column' && item.type !== 'void-circle' ? React.createElement(
      If,
      { condition: item.selected },
      React.createElement(
        'g',
        { 'data-element-root': true,
          'data-prototype': item.prototype,
          'data-id': item.id,
          'data-selected': item.selected,
          'data-layer': layer.id,
          'data-part': 'rotation-anchor'
        },
        React.createElement('circle', { cx: '0', cy: '150', r: isDesktop ? SharedStyle.CONTROL_POINT_RADIUS : SharedStyle.CONTROL_POINT_RADIUS_BIG, style: STYLE_CIRCLE }),
        React.createElement('circle', { cx: '0', cy: '0', r: '150', style: STYLE_CIRCLE2 })
      )
    ) : null,
    React.createElement(
      If,
      { condition: item.selected && item.properties.get('width') !== undefined && item.getIn(['properties', 'width', 'length']) >= removePoint },
      React.createElement(
        'g',
        { 'data-element-root': true,
          'data-prototype': item.prototype,
          'data-id': item.id,
          'data-selected': item.selected,
          'data-layer': layer.id,
          'data-part': 'resize-anchor-width'
        },
        React.createElement('circle', { cx: item.getIn(['properties', 'width', 'length']) / 2, cy: '0',
          r: isDesktop ? SharedStyle.CONTROL_POINT_RADIUS : SharedStyle.CONTROL_POINT_RADIUS_BIG, style: SharedStyle.CONTROL_POINT_STYLE }),
        React.createElement(
          'g',
          { transform: 'translate(' + (item.getIn(['properties', 'width', 'length']) / 2 - (isDesktop ? 6 : 12)) + ' ' + (isDesktop ? -5 : -10) + ') \n          ' + (isDesktop ? 'scale(1, 1)' : 'scale(2, 2)') },
          React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', style: SharedStyle.CONTROL_POINT_ARROW_STYLE }),
          React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', transform: 'translate(12,0) rotate(180,0,5)', style: SharedStyle.CONTROL_POINT_ARROW_STYLE })
        )
      )
    ),
    React.createElement(
      If,
      { condition: item.selected && item.properties.get('depth') !== undefined && item.getIn(['properties', 'depth', 'length']) >= removePoint },
      React.createElement(
        'g',
        { 'data-element-root': true,
          'data-prototype': item.prototype,
          'data-id': item.id,
          'data-selected': item.selected,
          'data-layer': layer.id,
          'data-part': 'resize-anchor-depth'
        },
        React.createElement('circle', { cx: '0', cy: -item.getIn(['properties', 'depth', 'length']) / 2,
          r: isDesktop ? SharedStyle.CONTROL_POINT_RADIUS : SharedStyle.CONTROL_POINT_RADIUS_BIG, style: SharedStyle.CONTROL_POINT_STYLE }),
        React.createElement(
          'g',
          { transform: 'translate(' + (isDesktop ? -6 : -12) + '  ' + (-item.getIn(['properties', 'depth', 'length']) / 2 - (isDesktop ? 5 : 10)) + ') \n            ' + (isDesktop ? 'scale(1, 1)' : 'scale(2, 2)') },
          React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', transform: 'translate(6, 6) rotate(-90,0,5)',
            style: SharedStyle.CONTROL_POINT_ARROW_STYLE }),
          React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', transform: 'translate(6,-6) rotate(90,0,5)',
            style: SharedStyle.CONTROL_POINT_ARROW_STYLE })
        )
      )
    )
  );
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};